var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from "react-query";
import { OrganizationAppService } from "../../../services/app/organizationApp.service";
import { useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { AppService } from "../../../services/app/app.service";
import { AdminOrganizationAppService } from "../../../services/identity/adminOrganizationApp.service";
import { AdminUserTypePermittedAppsService } from "../../../services/identity/adminUserTypePermittedApps.service";
import { UserTypePermittedAppsService } from "../../../services/identity/userTypePermittedApps.service";
export var useOrganizationAppsQuery = function (enabled) {
    if (enabled === void 0) { enabled = true; }
    return useQuery('allOrganizationApps', function () {
        return OrganizationAppService.getAll({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "order", direction: "DESC" }]
            }
        });
    }, { enabled: enabled });
};
export var useOrganizationApps = function (enabled) {
    var _a;
    if (enabled === void 0) { enabled = true; }
    var query = useOrganizationAppsQuery(enabled);
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
export var useAdminOrganizationApps = function (organizationId, enabled) {
    var _a;
    if (enabled === void 0) { enabled = true; }
    var query = useQuery(['allAdminOrganizationApps', organizationId], function () { return AdminOrganizationAppService.getAllOrganizationApps({
        limit: {
            offset: 0,
            limit: 1000,
            sort: [{ field: "order", direction: "DESC" }]
        },
        organizationId: organizationId
    }); }, {
        enabled: enabled && !!organizationId
    });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
export var useAccordingOrganizationApps = function (adminAccess, organizationId) {
    var adminApps = useAdminOrganizationApps(organizationId, adminAccess);
    var organizationApps = useOrganizationApps(!adminAccess);
    return adminAccess ? adminApps : organizationApps;
};
export var useAdminUserTypePermittedApps = function (enabled) {
    var _a;
    if (enabled === void 0) { enabled = true; }
    var query = useQuery('allAdminUserTypePermittedApps', function () {
        return AdminUserTypePermittedAppsService.getAllUserTypePermittedApps({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "order", direction: "DESC" }]
            }
        });
    }, { enabled: enabled });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
export var useUserTypePermittedApps = function (enabled) {
    var _a;
    if (enabled === void 0) { enabled = true; }
    var query = useQuery('allUserTypePermittedApps', function () {
        return UserTypePermittedAppsService.getAllUserTypePermittedApps({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "order", direction: "DESC" }]
            }
        });
    }, { enabled: enabled });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
export var useAccordingUserTypePermittedApps = function (adminAccess) {
    var adminApps = useAdminUserTypePermittedApps(adminAccess);
    var userApps = useUserTypePermittedApps(!adminAccess);
    return adminAccess ? adminApps : userApps;
};
export var useCurrentAppId = function () {
    var appId = useParams().appId;
    return appId;
};
export var useCurrentApp = function () {
    var appId = useParams().appId;
    var query = useQuery(['currentApp', appId], function () { return __awaiter(void 0, void 0, void 0, function () {
        var allApps;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, OrganizationAppService.getAll({
                        limit: {
                            offset: 0,
                            limit: 1000,
                            sort: [{ field: "order", direction: "DESC" }]
                        }
                    })];
                case 1:
                    allApps = _b.sent();
                    return [2 /*return*/, (_a = allApps.content) === null || _a === void 0 ? void 0 : _a.find(function (app) { return app.id === appId; })];
            }
        });
    }); });
    return query.data;
};
export var useCurrentAppExternalQ = function () {
    var appId = undefined;
    var location = useLocation();
    var pathParts = location.pathname.split('/');
    if (pathParts.length > 1) {
        appId = pathParts[1];
    }
    return useQuery(['currentApp', appId], function () { return __awaiter(void 0, void 0, void 0, function () {
        var allApps;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, OrganizationAppService.getAll({
                        limit: {
                            offset: 0,
                            limit: 1000,
                            sort: [{ field: "order", direction: "DESC" }]
                        }
                    })];
                case 1:
                    allApps = _b.sent();
                    return [2 /*return*/, (_a = allApps.content) === null || _a === void 0 ? void 0 : _a.find(function (app) { return app.id === appId; })];
            }
        });
    }); });
};
export var useAppNameAsPageTitle = function () {
    var _a;
    var appInfo = useCurrentAppExternalQ();
    useEffect(function () {
        var _a, _b;
        if ((_a = appInfo.data) === null || _a === void 0 ? void 0 : _a.name) {
            document.title = "".concat((_b = appInfo.data) === null || _b === void 0 ? void 0 : _b.name, " - Crqlar");
        }
    }, [(_a = appInfo.data) === null || _a === void 0 ? void 0 : _a.name]);
};
export var useAppNameAsPageTitleViaSKU = function (sku) {
    var _a;
    var query = useQuery(['currentApp', 'code', sku], function () { return __awaiter(void 0, void 0, void 0, function () {
        var allOrganizationApps, allApps, appViaSKU;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, OrganizationAppService.getAll({
                        limit: {
                            offset: 0,
                            limit: 1000,
                            sort: [{ field: "order", direction: "DESC" }]
                        }
                    })];
                case 1:
                    allOrganizationApps = _c.sent();
                    return [4 /*yield*/, AppService.getAll({
                            limit: {
                                offset: 0,
                                limit: 1000,
                                sort: [{ field: "order", direction: "DESC" }]
                            }
                        })];
                case 2:
                    allApps = _c.sent();
                    appViaSKU = (_a = allApps.content) === null || _a === void 0 ? void 0 : _a.find(function (app) { return app.sku === sku; });
                    return [2 /*return*/, (_b = allOrganizationApps.content) === null || _b === void 0 ? void 0 : _b.find(function (app) { return app.appId === (appViaSKU === null || appViaSKU === void 0 ? void 0 : appViaSKU.id); })];
            }
        });
    }); });
    useEffect(function () {
        var _a, _b;
        if ((_a = query.data) === null || _a === void 0 ? void 0 : _a.name) {
            document.title = "".concat((_b = query.data) === null || _b === void 0 ? void 0 : _b.name, " - Crqlar");
        }
    }, [(_a = query.data) === null || _a === void 0 ? void 0 : _a.name]);
};
